"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullRescanBalancesAllWallets = exports.resetFullTXIDMerkletrees = exports.rescanFullUTXOMerkletreesAndWallets = exports.scanUpdatesForMerkletreeAndWallets = exports.refreshRailgunBalances = void 0;
const error_1 = require("../../../utils/error");
const engine_1 = require("../core/engine");
const refreshRailgunBalances = async (chain, railgunWalletID, fullRescan, progressCallback) => {
    try {
        const wallet = (0, engine_1.walletForID)(railgunWalletID);
        if (fullRescan) {
            await wallet.fullRescanBalances(chain, progressCallback);
        }
        else {
            await wallet.scanBalances(chain, progressCallback);
        }
        // Wallet will trigger .emit('scanned', {chain}) event when finished,
        // which calls `onBalancesUpdate` (balance-update.ts).
        // Also kick off a background merkletree scan.
        // This will also call wallet.scanBalances when it's done, but may take longer.
        // So the user will see balances refresh from existing merkletree first.
        const engine = (0, engine_1.getEngine)();
        await engine.scanHistory(chain);
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.refreshRailgunBalances.name, err);
    }
};
exports.refreshRailgunBalances = refreshRailgunBalances;
const scanUpdatesForMerkletreeAndWallets = async (chain) => {
    try {
        const engine = (0, engine_1.getEngine)();
        await engine.scanHistory(chain);
        // Wallet will trigger .emit('scanned', {chain}) event when finished,
        // which calls `onBalancesUpdate` (balance-update.ts).
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.scanUpdatesForMerkletreeAndWallets.name, err);
    }
};
exports.scanUpdatesForMerkletreeAndWallets = scanUpdatesForMerkletreeAndWallets;
const rescanFullUTXOMerkletreesAndWallets = async (chain) => {
    try {
        const engine = (0, engine_1.getEngine)();
        await engine.fullRescanUTXOMerkletreesAndWallets(chain);
        // Wallet will trigger .emit('scanned', {chain}) event when finished,
        // which calls `onBalancesUpdate` (balance-update.ts).
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.rescanFullUTXOMerkletreesAndWallets.name, err);
    }
};
exports.rescanFullUTXOMerkletreesAndWallets = rescanFullUTXOMerkletreesAndWallets;
const resetFullTXIDMerkletrees = async (chain) => {
    try {
        const engine = (0, engine_1.getEngine)();
        await engine.fullResetRailgunTxidMerkletrees(chain);
    }
    catch (err) {
        throw (0, error_1.reportAndSanitizeError)(exports.resetFullTXIDMerkletrees.name, err);
    }
};
exports.resetFullTXIDMerkletrees = resetFullTXIDMerkletrees;
const fullRescanBalancesAllWallets = async (chain, progressCallback) => {
    const engine = (0, engine_1.getEngine)();
    await engine.scanAllWallets(chain, progressCallback);
};
exports.fullRescanBalancesAllWallets = fullRescanBalancesAllWallets;
